import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

/**
 * Gates the `issueLinks { edges }` selection that the Work Item View (Relay-only)
 * path adds to `WorkItemHeaderActions_issue` so the "Catch up on linked items" Rovo nudge
 * can determine `hasLinkedIssues` without a Redux store.
 *
 * Mirrors the experiment used by `useCatchUpNudge` (`rovo_catch_up_linked_items_nudge`)
 * so non-eligible cohorts never request the extra field (zero network cost).
 *
 * IMPORTANT: this reads the experiment with NO exposure. Evaluating the provider only
 * means the query *could* fetch link data — the nudge may still never render (it also
 * needs hasLinkedIssues, MODAL view, Rovo entitlement, not-skipped, and seen/consent
 * checks). Firing exposure here would over-count and skew the experiment. Exposure is
 * fired by `useCatchUpNudge` at the point the nudge is actually shown.
 */
const rovoCatchUpLinkedItemsNudgeRelayProvider = {
	get(): boolean {
		const [config] = UNSAFE_noExposureExp('rovo_catch_up_linked_items_nudge');
		return config.get('isEnabled', false);
	},
};

export default rovoCatchUpLinkedItemsNudgeRelayProvider;
